import {
  Box,
  Image,
  NamespacedImageKeys,
  Text,
  TextProps,
} from '@bonanza-social/moonlight';

type FeatureTipProps = {
  featureTip: {
    descriptionKey: TextProps['locKey'];
    image: NamespacedImageKeys;
  };
};

function FeatureTip({ featureTip }: FeatureTipProps) {
  return (
    <Box flexDirection="row" gap="space-200" marginBottom="space-300">
      <Image name={featureTip.image} width={35} height={35} />
      <Text
        variant="caption"
        color="darkSurfacePrimary"
        locNS="registration"
        locKey={featureTip.descriptionKey}
        alignSelf="center"
      />
    </Box>
  );
}

export default FeatureTip;
